<script setup lang="ts">
import type { Schemas } from '#shopware'

const props = defineProps<{
    content: Schemas['CmsElementCategoryNavigation'],
}>()

const onlySubcategories = computed(() => props.content.config?.onlySubcategories?.value === true)

const navigation = inject<Ref<Schemas["NavigationRouteResponse"] | null>>('mainNavigation', ref(null))

// The sidebar needs the deep category tree, which is deferred (see layouts/default.vue).
// Trigger it on mount so category/listing pages populate the sidebar without waiting for a
// mega-menu interaction. Idempotent — coalesces with any other trigger on the page.
const loadMainNavigation = inject<() => void>('loadMainNavigation', () => {})
onMounted(loadMainNavigation)
</script>

<template>
    <LayoutNavigationSidebar
        v-if="navigation"
        :navigation="navigation"
        :only-subcategories="onlySubcategories"
    />
</template>
